import { Component, Input, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { SlingConfigService } from 'src/app/services/sling-config.service';
import { BoatLogModalComponent } from '../boat-log-modal/boat-log-modal.component';

@Component({
  selector: 'app-boat-log-table',
  templateUrl: './boat-log-table.component.html',
  styleUrls: ['./boat-log-table.component.scss']
})
export class BoatLogTableComponent implements OnInit {

  @Input()
  boatLogs = [];

  @Input()
  isDialog = false;

  numberOfRows = 10;

  constructor(
    private slingConfigService: SlingConfigService,
    public dialog: DialogService,
  ) { }

  ngOnInit(): void {
    if ( !this.isDialog) {
      this.loadSlingConfig();
    }
  }

  loadSlingConfig(): void {
    this.slingConfigService.getSlingConfig().subscribe(
      (data) => {
        const slingConfig = data[0];
        if (slingConfig != null) {
          this.numberOfRows = slingConfig.numberOfRecordsPerPage;
        } else {
          this.numberOfRows = 10;
        }
      },
      (error) => null);
  }

  concatSailors(boatSailors) {
    if (!boatSailors) {
      return '';
    } else {
      let boatSailorConcat = '';
      boatSailors.forEach((seilor, index) => {
        if (index == 0) {
          boatSailorConcat = seilor.fullName;
        } else {
          boatSailorConcat = `${boatSailorConcat}, ${seilor.fullName}`
        }
      })
      return boatSailorConcat;
    }
  }

  openBoatLogDialog(boatLog): void {
    this.dialog.open(BoatLogModalComponent, {
      height: '85vh',
      width: '80%',
      dismissableMask: false,
      data: {
        boatLog
      },
      header: 'Log de Embarcação'
    })
  }

}
